// // src/components/FilterDrawer.jsx

// import { useState, useEffect } from 'react';
// import { fetchFilters } from '../api/filtersApi';

// export default function FilterDrawer({
//   isFilterOpen,
//   onClose,
//   selectedFilters,
//   onFilterChange,
//   onClearFilters,
// }) {
//   const [filterOptions, setFilterOptions] = useState({});
//   const [openFilters, setOpenFilters] = useState(new Set());

//   // Load filter options from API on mount
//   useEffect(() => {
//     const loadFilters = async () => {
//       try {
//         const data = await fetchFilters();
//         setFilterOptions(data.filters);
//       } catch (err) {
//         console.error('Failed to load filter options', err);
//       }
//     };
//     loadFilters();
//   }, []);

//   const toggleFilterGroup = (group) => {
//     const newOpenFilters = new Set(openFilters);
//     if (newOpenFilters.has(group)) {
//       newOpenFilters.delete(group);
//     } else {
//       newOpenFilters.add(group);
//     }
//     setOpenFilters(newOpenFilters);
//   };

//   const toggleFilter = (group, value) => {
//     onFilterChange(group, value);
//   };

//   return (
//     <>
//       {isFilterOpen && (
//         <div className="fixed inset-0 z-50 flex">
//           {/* Backdrop */}
//           <div
//             className="flex-1 bg-black bg-opacity-50"
//             onClick={onClose}
//           />

//           {/* Sidebar */}
//           <div className="w-80 bg-white h-full shadow-lg p-6 overflow-y-auto">
//             <div className="flex justify-between items-center mb-6">
//               <h2 className="text-lg font-semibold">Filters</h2>
//               <button onClick={onClose} className="text-gray-600">
//                 ✕
//               </button>
//             </div>

//             <button
//               onClick={onClearFilters}
//               className="text-sm text-blue-600 mb-6 hover:underline"
//             >
//               Clear All
//             </button>

//             {/* Selected Filter Pills */}
//             {Object.keys(selectedFilters).map((group) =>
//               Array.from(selectedFilters[group]).map((value) => (
//                 <span
//                   key={`${group}-${value}`}
//                   className="inline-flex items-center gap-1 bg-gray-200 text-gray-800 text-xs px-3 py-1 rounded-full mr-2 mb-2"
//                 >
//                   {value}
//                   <button
//                     type="button"
//                     onClick={() => toggleFilter(group, value)}
//                     className="text-gray-500 hover:text-gray-700"
//                   >
//                     ✕
//                   </button>
//                 </span>
//               ))
//             )}

//             {/* No filters selected */}
//             {Object.values(selectedFilters).every(set => set.size === 0) && (
//               <p className="text-sm text-gray-500 mb-6">No filters selected</p>
//             )}

//             {/* Collapsible Filter Groups */}
//             {Object.keys(filterOptions).map((group) => {
//               const displayName = group
//                 .replace(/_/g, ' ')
//                 .replace(/\b\w/g, (l) => l.toUpperCase());
//               const isOpen = openFilters.has(group);

//               return (
//                 <div key={group} className="border-t border-gray-200 pt-4">
//                   {/* Filter Heading */}
//                   <button
//                     type="button"
//                     className="flex justify-between w-full font-medium text-gray-800 text-sm uppercase tracking-wide"
//                     onClick={() => toggleFilterGroup(group)}
//                   >
//                     {displayName}
//                     <span className="text-gray-500 transform transition-transform duration-200">
//                       {isOpen ? '−' : '+'}
//                     </span>
//                   </button>

//                   {/* Filter Options */}
//                   {isOpen && (
//                     <div className="mt-3 space-y-2 max-h-60 overflow-y-auto pl-1 border-l-2 border-gray-100">
//                       {filterOptions[group].map((value) => (
//                         <label
//                           key={value}
//                           className="flex items-center gap-2 text-sm text-gray-700 hover:text-gray-900 cursor-pointer"
//                         >
//                           <input
//                             type="checkbox"
//                             checked={selectedFilters[group]?.has(value) || false}
//                             onChange={() => toggleFilter(group, value)}
//                             className="rounded border-gray-300"
//                           />
//                           {value}
//                         </label>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// src/components/FilterDrawer.jsx

import { useState, useEffect } from "react";
import { fetchFilters } from "../api/filtersApi";

export default function FilterDrawer({
  isFilterOpen,
  onClose,
  selectedFilters,
  onFilterChange,
  onClearFilters,
  onApplyFilters, // ← New callback
}) {
  const [filterOptions, setFilterOptions] = useState({});
  const [openFilters, setOpenFilters] = useState(new Set());

  // Load filter options from API
  useEffect(() => {
    const loadFilters = async () => {
      try {
        const data = await fetchFilters();
        setFilterOptions(data.filters);
      } catch (err) {
        console.error("Failed to load filter options", err);
      }
    };
    loadFilters();
  }, []);

  const toggleFilterGroup = (group) => {
    const newOpenFilters = new Set();
    if (!openFilters.has(group)) {
      newOpenFilters.add(group);
    }
    setOpenFilters(newOpenFilters);
  };

  const toggleFilter = (group, value) => {
    onFilterChange(group, value);
  };

  const handleApply = () => {
    const filtersToApply = {
      department_name: Array.from(selectedFilters.department_name || []).join(
        ","
      ),
      colour_group_name: Array.from(
        selectedFilters.colour_group_name || []
      ).join(","),
    };

    // Only apply if at least one filter is selected
    if (filtersToApply.department_name || filtersToApply.colour_group_name) {
      onApplyFilters(filtersToApply);
    } else {
      onApplyFilters({}); // Fetch all
    }
    onClose(); // Close drawer after apply
  };

  return (
    <>
      {isFilterOpen && (
        <div className="fixed inset-0 z-50 flex">
          <div className="flex-1 bg-black bg-opacity-50" onClick={onClose} />

          <div className="w-80 bg-white h-full shadow-lg p-6 overflow-y-auto">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl font-semibold text-gray-900">Filters</h2>

              <button
                onClick={onClose}
                className="text-gray-600 hover:text-gray-900 text-2xl focus:outline-none"
                aria-label="Close filters"
              >
                ✕
              </button>
            </div>

            {/* Selected Pills */}
            {Object.keys(selectedFilters).map((group) =>
              Array.from(selectedFilters[group]).map((value) => (
                <span
                  key={`${group}-${value}`}
                  className="inline-flex items-center gap-1 bg-blue-100 text-blue-800 text-xs px-3 py-1 rounded-full mr-2 mb-2"
                >
                  {value}
                  <button
                    type="button"
                    onClick={() => toggleFilter(group, value)}
                    className="text-blue-500 hover:text-blue-700 ml-1"
                  >
                    ✕
                  </button>
                </span>
              ))
            )}

            {Object.values(selectedFilters).every((set) => set.size === 0) && (
              <p className="text-sm text-gray-500 mb-6">No filters selected</p>
            )}

            {/* Filter Groups */}
            {Object.keys(filterOptions).map((group) => {
              const displayName = group
                .replace(/_/g, " ")
                .replace(/\b\w/g, (l) => l.toUpperCase());
              const isOpen = openFilters.has(group);

              return (
                <div key={group} className="border-t border-gray-200 pt-4">
                  <button
                    type="button"
                    className="flex justify-between w-full font-medium text-gray-800 text-sm uppercase tracking-wide hover:text-blue-600"
                    onClick={() => toggleFilterGroup(group)}
                  >
                    {displayName}
                    <span
                      className={`transform transition-transform ${
                        isOpen ? "rotate-180" : ""
                      }`}
                    >
                      ▼
                    </span>
                  </button>

                  <div
                    className={`mt-3 space-y-2 pl-1 border-l-2 border-gray-100 overflow-hidden transition-all duration-300 ${
                      isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                    }`}
                  >
                    {filterOptions[group].map((value) => (
                      <label
                        key={value}
                        className="flex items-center gap-2 text-sm text-gray-700 hover:text-blue-600 cursor-pointer"
                      >
                        <input
                          type="checkbox"
                          checked={selectedFilters[group]?.has(value) || false}
                          onChange={() => toggleFilter(group, value)}
                          className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                        />
                        {value}
                      </label>
                    ))}
                  </div>
                </div>
              );
            })}

            {/* Apply Button */}
            <div className="mt-8 pt-6 border-t border-gray-200">
              <button
                onClick={handleApply}
                className="w-full py-3 bg-black text-white font-semibold rounded-md hover:bg-gray-800 transition-colors"
              >
                APPLY FILTERS
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
